import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

const AllNotification = () => {

    const notifications = [
        { id: 517, text: "The details of a shared safari you have joined have been updated | Melghat Tiger Reserve", time: " 15 days ago" },
        { id: 303, text: "The details of a shared safari you have joined have been updated | Melghat Tiger Reserve", time: "29 days ago" },
        { id: 302, text: "The details of a shared safari you have joined have been updated | Melghat Tiger Reserve", time: "1 months ago" },
        { id: 235, text: "The details of a shared safari you have joined have been updated | Kanha Tiger Reserve", time: "3 months ago" },
        { id: 218, text: "The details of a shared safari you have joined have been updated | Kanha Tiger Reserve", time: "7 months ago" },
        { id: 185, text: "The details of a shared safari you have joined have been updated | Kanha Tiger Reserve", time: "1 years ago" },
      ];

  return (
    <>
      <Container className="mt-5 pt-5">
       <Row className="margin_bottomfooter">
        <Col md={7} className="offset-md-3">
        <div className=" d-flex align-items-center justify-content-between mb-4">
            <h6 className="fs-3 fw-bold ">Notifications</h6>
        </div>
        <Card className="account-settingside" style={{minHeight: "500px"}}>
          <Card.Body className="p-4">
           <h6 className="fs-5 fw-bold mb-3"> Recivied Notifications</h6>
           <ol>
           {notifications.map((notif) => (
           <>
            <li key={notif.id} className="">
              <a href={`/account/notification/view?id=${notif.id}`}>
                {notif.text}
              </a>
              <br /> <span className="fss-3">{notif.time}</span>
            </li>
           </>
          ))}
           </ol>
          </Card.Body>
        </Card>
        </Col>
       </Row>
      </Container>
    </>
  );
};

export default AllNotification;
